// import { default as fonts } from './base/_fonts';
import { default as scroll } from './base/_scroll';
import { default as mainMenu } from './modules/_main-menu';
import { default as loadMore } from './base/_load-more';
import { default as validation } from './modules/_validation';
import { default as slideshow } from './modules/_slide-show';
import { default as tables } from './modules/_tables';

(function () {

	// fonts.init();
	scroll.init();
	mainMenu.init();
	loadMore.init();
	validation.init();
	slideshow.init();
	tables.init();

})();